(() => {
  if (window.ffcReferenceNavigationBound) return;
  window.ffcReferenceNavigationBound = true;
  const positionMenus = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const edge = 20;
    const viewportWidth = document.documentElement.clientWidth;
    document.querySelectorAll('.ffc-ref-menu[open]').forEach((menu) => {
      const panel = menu.querySelector(':scope > .ffc-ref-menu__panel');
      if (!panel) return;
      panel.style.setProperty('--ffc-menu-offset', '0px');
      const bounds = panel.getBoundingClientRect();
      const offset = Math.max(edge - bounds.left, Math.min(0, viewportWidth - edge - bounds.right));
      panel.style.setProperty('--ffc-menu-offset', `${offset}px`);
      const positioned = panel.getBoundingClientRect();
      menu.querySelectorAll('.ffc-ref-submenu__panel').forEach((subpanel) => {
        const available = viewportWidth - edge - positioned.right;
        const below = available < 350;
        const width = Math.min(840, below ? viewportWidth - edge * 2 : available);
        subpanel.style.setProperty('--ffc-submenu-width', `${width}px`);
        subpanel.style.setProperty('--ffc-submenu-columns', String(Math.max(2, Math.min(4, Math.floor(width / 180)))));
        subpanel.style.setProperty('--ffc-submenu-left', below ? `${edge - positioned.left}px` : 'calc(100% - 1px)');
        subpanel.style.setProperty('--ffc-submenu-top', below ? '100%' : '-1px');
      });
    });
  };
  document.addEventListener('toggle', (event) => {
    if (event.target.matches('.ffc-ref-menu, .ffc-ref-submenu')) positionMenus();
  }, true);
  window.addEventListener('resize', positionMenus);
  const closeMenus = (except) => {
    document.querySelectorAll('.ffc-ref-menu[open], .ffc-ref-mobile-menu[open]').forEach((menu) => {
      if (menu !== except) {
        menu.open = false;
        menu.querySelectorAll('details[open]').forEach((child) => { child.open = false; });
      }
    });
  };
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.ffc-ref-menu, .ffc-ref-mobile-menu');
    closeMenus(menu);
    const subgroup = event.target.closest('.ffc-ref-submenu, .ffc-ref-mobile-group');
    if (subgroup && event.target.closest('summary') === subgroup.querySelector('summary')) {
      subgroup.parentElement.querySelectorAll(':scope > details[open]').forEach((sibling) => {
        if (sibling !== subgroup) sibling.open = false;
      });
    }
    if (menu && event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('focusin', (event) => {
    if (!event.target.closest('.ffc-ref-nav, .ffc-ref-mobile-menu')) closeMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const subgroup = event.target.closest('.ffc-ref-submenu[open], .ffc-ref-mobile-group[open]');
    if (subgroup) {
      subgroup.open = false;
      subgroup.querySelector('summary').focus();
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const menu = event.target.closest('.ffc-ref-menu[open], .ffc-ref-mobile-menu[open]');
    if (menu) menu.querySelector('summary').focus();
    closeMenus();
  });
})();
